import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@els/els-react--button';
import { Flyout } from '@els/els-react--flyout';
import { connect } from 'react-redux';
import { initials as getInitials } from '@Containers/Header/HeaderComponentSelectors';
import NamedUserContainer from './NamedUserContainer';

import './NamedUser.scss';

function NamedUser({ initials }) {
  const [isFlyoutOpen, setIsFlyoutOpen] = useState(false);
  const flyoutRef = useRef(null);

  const closeFlyout = useCallback(() => {
    setIsFlyoutOpen(false);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (flyoutRef.current && !flyoutRef.current.contains(event.target)) {
        closeFlyout(); // Close the pop-up
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [closeFlyout]);

  return (
    <li className="u-els-padding-left-1o2 rx-menu-item--user u-els-display-none@tablet">
      <Flyout
        isControlled
        isOpen={isFlyoutOpen}
        placement="bottom-end"
        pointer
        pointerType="primary"
        showCloseButton
        flyout={
          <div ref={flyoutRef} className="u-els-margin-right-3x">
            <NamedUserContainer closeFlyout={closeFlyout} />
          </div>
        }>
        <Button
          id="logged-in-user-dropdown-button"
          type="transparent"
          className="u-els-background-color-n7 profile-dd rounded-circle cp"
          aria-label="Profile"
          onClick={() => setIsFlyoutOpen(!isFlyoutOpen)}>
          {initials}
        </Button>
      </Flyout>
    </li>
  );
}

NamedUser.propTypes = {
  initials: PropTypes.string,
};

const mapStateToProps = (state) => ({
  initials: getInitials(state),
});

export default connect(mapStateToProps)(NamedUser);
